import { Component, Input } from '@angular/core';

import { FeatureFlags } from '@app/core/feature-flags/feature-flags';
import { LaunchDarklyService } from '@app/core/feature-flags/launchdarkly.service';

@Component({
  selector: 'om-scribe-consent-description',
  templateUrl: './scribe-consent-description.component.html',
})
export class ScribeConsentDescriptionComponent {
  @Input() headerLevel = 5;
  @Input() headerClasses?: string;
  @Input() bodyClasses = 'mb-2';
  showScribeFaq = false;

  constructor(private launchDarklyService: LaunchDarklyService) {
    this.launchDarklyService.featureFlag$(FeatureFlags.SCRIBE_FAQS_WEBVIEW, false).subscribe(enabled => {
      this.showScribeFaq = enabled;
    });
  }

  get headerClass(): string {
    const parsedHeaderLevel =
      this.headerLevel >= 1 && this.headerLevel <= 6 && Number.isInteger(this.headerLevel) ? this.headerLevel : 5;
    return `h${parsedHeaderLevel} ${this.headerClasses}`;
  }

  get bodyClass(): string {
    return this.bodyClasses ?? '';
  }
}
